module.exports = __webpack_public_path__ + "img/performance-1.a78aebf7.png";